import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const CompareContext = createContext(null);
const KEY = 'axicor_compare_slugs';
export const MAX_COMPARE = 4;

export const useCompare = () => useContext(CompareContext);

export function CompareProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(saved) ? saved.slice(0, MAX_COMPARE) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const has = useCallback((slug) => items.some(i => i.slug === slug), [items]);

  const toggle = useCallback((grade) => {
    if (items.some(i => i.slug === grade.slug)) {
      setItems(items.filter(i => i.slug !== grade.slug));
      return 'removed';
    }
    if (items.length >= MAX_COMPARE) return 'full';
    setItems([...items, { slug: grade.slug, name: grade.name, category_slug: grade.category_slug || '' }]);
    return 'added';
  }, [items]);
  const remove = useCallback((slug) => setItems(prev => prev.filter(i => i.slug !== slug)), []);
  const clear = useCallback(() => setItems([]), []);
  const replace = useCallback((list) => setItems(list.slice(0, MAX_COMPARE)), []);

  return (
    <CompareContext.Provider value={{ items, has, toggle, remove, clear, replace }}>
      {children}
    </CompareContext.Provider>
  );
}
